import { getFormattedDate } from '@/helpers/time'
import { differenceInMinutes } from 'date-fns'

export const getTakeoverDifferenceInMinutes = ({
    dateOfIssue,
    takeoverTime,
    actualTakeoverTime,
}: {
    dateOfIssue: string
    takeoverTime: string
    actualTakeoverTime: string
}): number => {
    try {
        const takeoverDate = getFormattedDate({
            date: dateOfIssue,
            time: takeoverTime,
        })
        const actualTakeoverDate = getFormattedDate({
            date: dateOfIssue,
            time: actualTakeoverTime,
        })

        return differenceInMinutes(actualTakeoverDate, takeoverDate)
    } catch (error) {
        return 0
    }
}
